import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-hero" }
const _hoisted_2 = { class: "text-gray-600 body-font" }
const _hoisted_3 = { class: "container mx-auto flex px-5 py-24 items-center justify-center flex-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "lg:w-2/6 md:w-3/6 w-5/6 mb-10 object-cover object-center rounded",
  alt: "hero",
  src: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80"
}, null, -1)
const _hoisted_5 = { class: "text-center lg:w-2/3 w-full" }
const _hoisted_6 = { class: "hero-title" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Create a quick invoice for your ")
const _hoisted_8 = ["textContent"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-8 leading-relaxed" }, [
  /*#__PURE__*/_createTextVNode(" With simple and easy-to-use designs. And a privacy-first service that doesn't store your data on its servers. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Sounds interesting? Create a quick invoice now 👇 ")
], -1)
const _hoisted_10 = { class: "flex justify-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Explore Templates ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("strong", {
              class: "text-primary-500",
              textContent: _toDisplayString(_ctx.invoiceFor)
            }, null, 8, _hoisted_8)
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: { name: `SelectTemplate` },
              tag: "button",
              class: "inline-flex text-white bg-primary-500 border-0 py-2 px-6 focus:outline-none hover:bg-primary-600 rounded text-lg"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}